
const GlobalStyle = (theme) => {
  let config =JSON.parse(sessionStorage.getItem("tenantConfig"))||{};
  let colorSwitcherOne = config.colorSwitcherOne||config.ButtonandLeftBarColor||'#000000';
  let colorSwitcherTwo = config.colorSwitcherTwo||config.BordersColor||'#45719b';
  let colorSwitcherThree = config.colorSwitcherThree||config.BordersColor||'#4d719b';
  let loginTopBoxShadow = config.loginTopBoxShadow||config.BordersColor||'#3d719b';
  let loginBackgroundColor = config.loginBackgroundColor||'#3d719b';
  let forgotFontColor = config.forgotFontColor||'#7f1734';
  let buttonFontColor = config.buttonFontColor||'#ffffff';
  let disableButtonColor = config.disableButtonColor||'#a59d9d';
  let allHeaderFontSize = config.allHeaderFontSize||'1.2rem';
  let allTitleFontSize = config.allTitleFontSize||'1rem';
  return {
    colorTextOne:{
      color:colorSwitcherOne
    },
    colorBgOne: props=>{
      return {
        background:colorSwitcherOne
      }
    },
    button: {
      // margin: theme.spacing(1, 1, 1),
      backgroundColor: colorSwitcherOne,
      padding: theme.spacing(1, 2),
      color: buttonFontColor,
      '&:hover': {
        background: colorSwitcherThree,
      },
      display:'inline-block',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    tabSelected:{
      color:`${colorSwitcherOne}!important`
    },
    wrapper: {
      width: '100%',
      backgroundSize: 'cover',
    },
    PlusBgColor:{
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
      borderRadius: '50%',
      width: '40px',
      height: '40px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '-12px',
    },
    addRemoveTenantIcon:{
      backgroundColor: 'red'
    },
    disableBtn:{
      margin:'0',
      backgroundColor: disableButtonColor,
      padding: '8px 16px',
      color:"#6e6c6c",
      display:'inline-block',
      [theme.breakpoints.down('sm')]: {
        backgroundColor:"" + disableButtonColor +" !important",
        color:"#6e6c6c !important",
      },
    },
    message:{
      fontSize: '12px',
      color: 'red',
      paddingLeft:5
    },
    logo: {
      textAlign: 'center',
      height: 'auto',
      backgroundRepeat: 'no-repeat',
      margin: '0 auto',
      backgroundPosition: 'center',
      borderRadius:'unset',
      width: '262px',
      objectFit: 'unset',
      display: 'table'
    },
    forgotpwd: {
      display: 'flex',
      verticalAlign: 'text-bottom',
      alignItems: 'center',
      fontSize: '0.8em',
      justifyContent:'end'
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(2),
    },
    forgotFontSize: {
      color: forgotFontColor,
      fontSize: allTitleFontSize,
      '&:hover': {
        color: '#d62631',
        textDecoration: "none"
      }
    },
    myTableTest:{
      color:'red'
    },
    containerbg: {
      backgroundColor: loginBackgroundColor,
      borderRadius: 15,
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: "0px -8px" + loginTopBoxShadow +"",
      border:"1px solid" + loginTopBoxShadow +"",
      width: '385px',
      padding: '45px 35px',
      [theme.breakpoints.down('sm')]: {
        width: 327,
        padding: 20,
      },
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    // Search Student
    userHeader: {
      textAlign: 'center',
      color: colorSwitcherTwo,
      fontSize: allHeaderFontSize,
      fontWeight: 'normal',
      marginBottom: '30px',
      [theme.breakpoints.down('sm')]:{
        marginBottom: '29px'
      },
    },
    SearchUser: {
        width: '100%',
    },
    label: {
      color: '#ff0000'    
    },
    // end of Search Student
    buttonProgress:{
      color: colorSwitcherThree,
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    progressInside:{
      margin: theme.spacing(0),
      position: 'relative',
    },
    progressOutside:{
      display: 'flex',
      alignItems: 'center',
      // marginTop:'-8px'
    },
    // Tickets property
    tablestyle: {
      marginTop: '15px',
      display: 'inline-block',
      width: '100%',
      zIndex: '0'
    },
    topBorderShed: {
      boxShadow: "0px -7px "+ colorSwitcherTwo +"",
      padding: '35px 0px',
      borderRadius: '14px',
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        display:'none',
      },
    },
    boxBorder:{
      borderTop: '5px solid',
      borderTopColor: colorSwitcherTwo,
      borderRadius: '14px',
      background:'#fff',
      padding:'20px',
      marginTop:'35px',
      boxShadow:'0 0 3px rgba(0,0,0,0.1)'
    },

    desctext:{
      padding:'0',
      marginLeft:'5px',
      marginTop:'0px',
      marginBottom:'13px'
    },
    paper: {
      root: {
        marginTop: '15px'
      }
    },
    formControl: {
      margin: theme.spacing(1),
    },
    formControls: {
      width: '100%',
      margin: '8px 0',
      border: '1px solid #c1c1c1',
      padding: '0 16px',
      borderRadius: '7px',
    },
    formControlAddTenant:{
      margin: 0,
      width: '100%'
    },
    textField: {
      margin: theme.spacing(1,0),
    },
    displayNone:{
      display: 'none'
    },  
    borderbox:{
      borderRadius: '15px',
      padding: '10px',
      background:'#fff',
      boxShadow: '0 0 5px #c1c1c1',
      borderTop:"7px solid" + colorSwitcherTwo + ""
    },
    mainWrapper:{
      width: '64%',
      position: 'relative',
      margin:'0 auto',
      marginTop:'75px',
      boxShadow: '0 0 5px #c1c1c1',
      padding: '47px 68px',
      borderRadius: '15px',
      background:'#fff',
      [theme.breakpoints.down('sm')]: {
        boxShadow: 'unset',
        padding: '0',
        top: '0',
        left: '0',
        width: '100%',
        textAlign:'center',
        marginTop: 34,
        background:'unset'
      },
    },
    mainHeader:{
      marginTop: 0,
      marginBottom:15,
      fontWeight: 500,
      fontSize: allHeaderFontSize,
      display:'inline-block',
      [theme.breakpoints.down('sm')]: {
        paddingLeft:0,
      },
    },
    studentName:{
      fontSize:16,
      margin:0
    },
    createBtn:{
      cursor:'pointer',
      color:'#fff',
      backgroundColor: colorSwitcherTwo,
      borderRadius: '50%',
      '&:hover': {
        backgroundColor: '#c3bcbc',
        color: "#fff"
      }
    },
    leftContainer:{
      marginTop:23,
      [theme.breakpoints.between('sm', 'md')]: {
        maxWidth: '18%!important'
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: '10%'
      },
      [theme.breakpoints.down('767')]: {
        maxWidth: '100%'
      },
      
    },
    
    dataGridContainer:{
      [theme.breakpoints.between('sm', 'md')]: {
        maxWidth: '78%!important' 
      },
      marginTop: '23px',
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        maxWidth: '90%',
        flexBasis: '90%'
      },
      [theme.breakpoints.down('767')]: {
        maxWidth: '100%',
        flexBasis: '100%'
      },
      
    },
    standardTitle:{
      fontWeight: 500,
      fontSize: '1.3rem',
      textAlign:'center'
    },
    inputlabelText:{
      backgroundColor:'#fff',
      margin: '8px -3px',
      padding: '0 6px'
    },
    
    MuiFormHelperText: {
        root: {
          color: "green",
            "&$error": {
                color: "#000000"
            }
        },
    },
    errowMessage:{
      color: '#ff0000',
      display: 'block',
      position: 'absolute',
      textAlign: 'left',
      left: '12px',
      bottom: '-26px'
    },
    tableCustomeClass:{
      color:'#ff0000'
    },
    popup:{
        // width:'400px',
        width: '578px',
        padding:'12px',
        overflow: 'hidden',
        '& DialogTitle':{
          margin:'0',
          padding:'10px',
        },
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
    },
    popupCustomize:{
      overflowY:'unset',
      padding: '20px'
    },
    popupclose:{
      top: '10px',
      right:'10px',
      color: '#000',
      boxShadow: '0 0 6px rgba(0,0,0,0.2)',
      position: 'absolute',
      background: '#fff',
      borderRadius:'100px',
      padding: '0px',
      width: '40px',
      lineHeight: '40px',
      fontSize: '1.3rem',
      minWidth: 'auto',
  },
  footerContainer:{
    color:"#757575",
    display: 'flex',
    justifyContent:'center',
    '& footer-header':{
      fontSize: 12,
      fontWeight: 500,
      textAlign: 'center',
      display: 'inline-table',
      letterSpacing: 'inherit',
      marginTop: 15,
      marginBottom: 15,
      zIndex:0
    },
    profileContainer:{
      
    },
    signOutButton:{
      color:'#ff0000'
    },
  },
  serverMessage:{
    position:'absolute',
    width:'300px',
    top:'-60px',
    left:'50%',
    marginLeft:'-150px',
    padding:'7px 35px',
    paddingLeft:'20px',
    borderRadius:'50px',
    background:colorSwitcherThree,
    '& p':{
      margin:'0',
      textAlign:'left',
      color:'#fff',
      minHeight:'20px',
      fontSize:'.9em',
      lineHeight:'1.2em'
      
    },
    '& button':{
      top: '-4px',
      right:'0',
      color: '#000',
      boxShadow: '0 0 6px rgba(0,0,0,0.2)',
      position: 'absolute',
      background: '#fff',
      borderRadius:'100px',
      padding: '0px',
      width: '42px',
      textAlign:'center',
      lineHeight: '42px',
      fontSize: '1.3rem',
      minWidth: 'auto',
      cursor:'pointer',
      textDecoration:'none',
      border: 'none'
    }
  },
  messageDisplay: {
      fontSize: '18px',
      width: '100%',
      height: '59px',
      marginBottom: '15px',
      color: '#fff',
      justifyContent: 'center',
      fontWeight: 500,
      backgroundColor: '#1a184e',
      display: 'flex',
      // padding: '10px 16px',
      position: 'relative',
      lineHeight: 1.43,
      borderRadius: '4px',
      letterSpacing: '0.01071em',
      boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
      
  },
  visitedAlertContainer:{
    position: 'absolute',
      width: '100%',
      left: 0,
      bottom: 0,
      right: 0,
  },

  tenantAlertMessagesContainer:{
    margin: theme.spacing(0,3),
    minWidth: '30%',
    position: 'fixed',
    width: '30%',
    border: '1px solid #c1c1c1',
    bottom: '56px',
    right: '0',
    backgroundColor: '#fff',
    zIndex: '9999',
    paddingBottom: '12px',
  },
  tenantAlervisitedtMessagesContainer:{
    margin: theme.spacing(0,3),
    minWidth: '30%',
    position: 'fixed',
    width: '30%',
    border: '1px solid #c1c1c1',
    // top:220,
    // bottom: '0px',
    right: '0',
    bottom: '56px',
    backgroundColor: '#fff',
    zIndex: '9999',
    paddingBottom: '12px',
  },
  tenantBoxTransiction:{
    transform: 'translate(0px, 253px)',
    transitionDuration: '5s',
  },
  alertContainer:{
    display:'block',
    position:'relative'
  },
  alertVisitedContainer:{
    display:'none'
  },
  alertServiceBtn:{
    margin: theme.spacing(1, 3),
    backgroundColor: colorSwitcherOne,
    padding: theme.spacing(1.3, 4.2),
    color: buttonFontColor,
    position: 'fixed',
    bottom: 0,
    right: 0,
    zIndex: '9999',
    '&:hover': {
      background: colorSwitcherThree,
    },
  },
  alertListBtn:{
    margin: theme.spacing(1, 0.5),
    backgroundColor: colorSwitcherOne,
    padding: theme.spacing(1.3, 4.2),
    color: buttonFontColor,
    zIndex: '999',
    '&:hover': {
      background: colorSwitcherThree,
    },
  },
  alertListBtnContainer:{
    display: 'inline-block',
    position: 'fixed',
    bottom: 0,
    zIndex: 999,
    left:'82px'
  },
  alertItem:{
    color: '#fff',
    margin: '10px 0',
    padding: '4px 10px',
    borderRadius: '15px',
    cursor: 'default',
    '& span':{
      fontSize:'0.8rem'
    }
  },
  alertMessageContainer:{
    marginLeft: '10px',width: '84%',whiteSpace: 'nowrap',overflow: 'hidden',textOverflow: 'ellipsis'
  },
  serviceAlertContainer:{
    margin: "15px 30px"
  },
  tenantCrossBtn:{
    margin: '-4px 5px',
    cursor: 'pointer',
    position: 'absolute',
    right:0,
    zIndex: '99999',
  },
  tenantTitle:{
    borderBottom: '1px solid #c1c1c1', 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '35px', 
    marginBottom:'5px',
    fontWeight: 500,
    fontSize: allHeaderFontSize,
  },
  show:{
    display: 'block'
  },
  rootTenant: {
    width: '100%',
  },
  headingTenant: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeadingTenant: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  iconTenant: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20,
  },
  detailsTenant: {
    alignItems: 'center',
    marginTop: '-13px',
  },
  columnTenant: {
    flexBasis: '100%',
    color: '#fff',
    cursor: 'default',
    paddingLeft: '12px',
    borderRadius: '49px',
    // backgroundColor: 'rgb(207, 51, 130)',
    display:'flex',
    alignItems:'center',
    fontSize:'14px',
    fontStyle:'italic'
  },
  tenantBody:{
    flexBasis: '100%',
    color: '#fff',
    cursor: 'default',
    padding: '0 12px',
    // backgroundColor: 'rgb(207, 51, 130,0.5)',
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
  },
  footerButtons:{
    position: 'fixed',
    bottom: 0,
    right: '0px',
    // width: '100%',
  },
  alertBodyHeaderandFooter :{
    fontSize: '0.8rem', textAlign: 'right', color: '#000', margin: '5px 0', fontStyle: 'italic'
  },
  alertBody:{color: '#fff', fontSize: '0.8rem'},
  columnsTenant: {
    flexBasis: '20%',
  },
  helperTenant: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  crossButtonStyle: {
    bottom: '47px !important',
    padding: 0,
    width: 50,
    height: 50,
    margin: '4px -12px',
    display: 'flex',
    alignItems: 'center',
    minWidth: 'auto',
    borderRadius: '50%',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.17) !important'
    }
  },
  tenantType :{
    color: '#fff', 
    borderRight: '1px solid #c1c1c1', 
    paddingRight: '10px', 
    paddingLeft: '5px', 
    backgroundColor: 'rgb(0,0,0,0.5)'
  },
  checkboxContainer :{
    float: 'right',
    marginRight: '-15px',
  },
  tenantWithCrossIcon:{
    backgroundColor: '#2B60DE',
    padding:'5px 11px',
    borderRadius : '30px',
    color: '#fff',
    display: 'inline-block',
    marginRight: '5px',
    marginBottom: '5px',
    lineHeight: '1.7'
  },
  tenantCrossIcon:{
    float:'right',
    padding: '2px',
    marginLeft: '6px',
    cursor: 'pointer',
  },
  saveTenant:{
    textAlign:'right',
    marginTop: '5px',
    '& button':{
      marginRight:0,
      backgroundColor: colorSwitcherOne,
      color:'#fff',
      '&:hover':{
        backgroundColor: colorSwitcherTwo
      }
    }
  },
  marginRight5:{
    marginRight:5
  },
  saveTenantContainer:{
    margin:15
  },
  linkTenant: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
        textDecoration: 'underline',
    },
  rootTest:{
    margin:0
  }
  }
    // End Of Tickets Property
  }
}


export default GlobalStyle;